import { addBasePath } from "../link-utils";
import { withParams } from "../link-utils";

export const studentBasePath = "";

export const studentLinks = addBasePath(studentBasePath)({
	cognitiveTests: "cognitive-tests",
});
